// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__27-6-","title":"AfterBackImages_title__IJoW3","images":"AfterBackImages_images__NYdLA"};